import React from 'react';

const TongueDescription: React.FC = () => {
    return (
        <div style={{ padding: '20px', fontSize: '14px' }}>
            <p>本页关于知源把脉养生APP内所包含的一些分析结果及部分数据来源参考说明</p>
            <p><strong style={{ fontSize: '18px' }}>一、参考文献如下：</strong></p>
            <p>
                1、"AI分析系统"的主要依据是中医四大经典《黄帝内经》《难经》《伤寒杂病论》《神农本草经》全国中医药行业高等教育"十三五"规划教材以及其他国家权威出版社出版的刊物和权威文献。
            </p>
            <p>
                2、《中医内科学》，吴勉华、石岩，ISBN:9787513268400，本为全国中医药行业高等教育"十四五"规划教材。全书分总论、各论和附录三部分。总论介绍中医内科学的定义、性质、范围、发展源流，中医内科疾病的分类、命名及其特点和辨证治疗方法。各论分八章，介绍六十多种常见病证，按肺系心系、脑系、脾胃系、肝胆系、肾系、气血津液、肢体经络病证顺序排列。本书以概念、病因病机、分析与鉴别分析、辨证论治等"三基"内容为重点，体现了教材的传承；基于临床实践，从知识综合、知识转化、知识运用角度设计临证备要、名医经验等部分；基于扩展学生视野，提高自主学习能力，设计文献摘要及数字化教材内容。[1]
            </p>
            <p>
                3、《方剂学》，王义祁，人民卫生出版社ISBN: 9787117261999，《中医方剂学》是阐述中医方剂配伍规律及临床运用的一门学科，是各级医学院、所及有关从业人员，研究中医业务的必修基础课程。有关著作依据《中医方剂学教学大纲》编写，各个中医院校自编或协编的教材，出版单位较多。[1]
            </p>
            <p>
                4、《中药学》，杨德全，人民卫生出版社ISBN: 9787117261982，本教材系第四轮全国中医药高职高专教材国家和卫生计生委"十三五"规划教材之。是在上版教材基础进行全面修订，以期反映中医药高职高专教育教学成果，职业教育特色，中医药人才培养规律。教材立足于农村基层医院与社区医疗服务，较上版增编了二维码数字内容，调整了基础理论，以适应全国中医药专科教育的需要。[1]
            </p>
            <p>
                5、《中医基础理论》，陈刚，人民卫生出版社：ISBN: 9787117262170，本教材系第四轮全国中医药高职高专教材国家和卫生计生委"十三五"规划教材之，是在上版教材基础进行全面修订，以期反映中医药高职高专教育教学成果，职业教育特色，中医药人才培养规律，教材立足于农村基层医院与社区医疗服务，较上版增编了二维码数字内容，调整了基础理论，以适应全国中医药专科教育的需要。是首套高职高专融合教材。[1]
            </p>
            <p>
                6、《针灸学》，甄德江，中国中医药出版社，ISBN：9787513249720，中华人民共和国国家标准（GB/T21709-2008）《针灸操作规范》腧穴定位参照[中华人民共和国国家标准（GB/T12346-2006）《腧穴名称与定位》]，对十四经穴（362个经穴）及常用经外穴（35个经外穴）进行标准化定位，使腧穴定位更加标准和准确；常见病证的分析参照《中华人民共和国中医药行业标准(ZY/T001.1-94)《病证分析疗效标准》），对常见病的定义、分析及证候分类进行规范的准确描述。[1]
            </p>
            <p>
                7、《针灸治疗》，王德敬，中医药出版社，ISBN: 9787513249713，针灸治疗技术是针灸推拿专业的一门重要专业核心技能课程，是研究和运用针灸疗法各科疾病一般规律的一门临床学科，是理论到临床的一门桥梁课程。[1]
            </p>
            <p>
                8、《中药学基础》，李承革．中国医药科技出版社有限公司，ISBN：9787506784115，本书系根据《中药学》教学大纲的基本要求和课程特点编写而成，内容涵盖中药的起源、中药的产地与采集、中药炮制、中药性能特点、中药的应用以及常用中药的性味归经、功效应用、用法用量、中药不良反应、主要药理作用、常用配伍、药膳等内容。本书供全国医药中等职业学校药学类专业教学使用。[1]
            </p>
            <p>
                9、《中药鉴定技术》，丁冬梅，中国医药科技出版社有限公司，ISBN：9787521421279，本书是全国医药中等职业教育"十三五"规划教材之一。根据本学科教学大纲的基本要求和课程特点编写而成。[1]
            </p>
            <p style={{ marginBottom: 0 }}>
                10、《中医护理》，魏素芳，华中科技大学出版社，ISBN：9787568027441，本书是全国中等卫生职业教育护理专业"十三五"规划教材。本书内容包括十个项目和附录部分。十个项目包括认识中医护理中医学的哲学基础、中医护理基本知识、中医诊法、中医辨证、预防护理原则、方药治疗及护理、针灸推拿疗法及护理、生活护理、常见病证的整体护理。[1]
            </p>
        </div>
    );
};

export default TongueDescription;